import React from 'react';
import useCollapse from 'react-collapsed';

function Section(props) {

  const data = props;

  const config = {
    defaultExpanded: data.defaultExpanded || false,
  };

  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse(config);

  return (
    <div className="collapsible">
      <div className="header" {...getToggleProps()}>
        <div className="btn no-btn no-border shadow-none w-50 text-left">
          <h3 className="title-change my-2">
            {!isExpanded ? <i className="fas fa-caret-right mr-1" /> : <i className="fas fa-caret-down mr-2" />} {data.title}
          </h3>
        </div>
      </div>
      <div {...getCollapseProps()}>
        <div className="content">
          {data.children}
        </div>
      </div>
    </div>
  );
}

export default Section;
